"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LOGOUT_CONFIRM_MESSAGE = exports.CANCEL_BUTTON_TEXT = void 0;
var LOGOUT_CONFIRM_MESSAGE = "Are you sure you want to \nLogout?";
exports.LOGOUT_CONFIRM_MESSAGE = LOGOUT_CONFIRM_MESSAGE;
var CANCEL_BUTTON_TEXT = "Cancel";
exports.CANCEL_BUTTON_TEXT = CANCEL_BUTTON_TEXT;
var _default = {
  LOGOUT_CONFIRM_MESSAGE: LOGOUT_CONFIRM_MESSAGE,
  CANCEL_BUTTON_TEXT: CANCEL_BUTTON_TEXT
};
exports["default"] = _default;